import PropTypes from 'prop-types';

const siteSettingsShape = PropTypes.shape({
  socialMedia: PropTypes.shape({
    facebookBool: PropTypes.bool,
    facebookUrl: PropTypes.string,
    instagramBool: PropTypes.bool,
    instagramUrl: PropTypes.string,
    youtubeBool: PropTypes.bool,
    youtubeUrl: PropTypes.string,
    twitterBool: PropTypes.bool,
    twitterUrl: PropTypes.string,
    pinterestBool: PropTypes.bool,
    pinterestUrl: PropTypes.string,
    tiktokBool: PropTypes.bool,
    tiktokUrl: PropTypes.string,
  }),
  warnings: PropTypes.string,
  productWarranty: PropTypes.string,
  shipping: PropTypes.number,
  returnDays: PropTypes.number,
  deliveryTimeEstimate: PropTypes.shape({
    minDeliveryDays: PropTypes.number,
    maxDeliveryDays: PropTypes.number,
  }),
});

export default siteSettingsShape;
